import { store } from '@betacrew/jars-flux'
import { put, all, takeLatest } from 'redux-saga/effects';
import { componentKey, setExportFile, setFormList, setLoadingState, setMemberUserHistory, setPayerList, setSelectedForm, setTaxYearList, setTotalHistory } from './MemberUserHistorySlice';
import HistoryDataService from '../../../../services/HistoryDataService';
import { COMMON_EXPORTING_STATES, COMMON_LOADING_STATES } from '../../constants/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import FormsDataService from '../../../../services/FormsDataService';
import Payer from '../../../../libs/utility/Payer';
import General from '../../../../libs/utility/General';

export const { getPayersList, getTaxYearsList, getFormsList, getMemberUserHistory, exportMemberUserHistoryExcel } = {
    getPayersList: (payload) => {
        return {
            type: "MEMBER_USER_HISTORY/GET_PAYERS",
            payload: payload
        }
    },
    getTaxYearsList: (payload) => {
        return {
            type: 'MEMBER_USER_HISTORY/GET_TAX_YEAR',
            payload
        }
    },
    getFormsList: (payload) => {
        return {
            type: "MEMBER_USER_HISTORY/GET_FORMS_LIST",
            payload: payload
        }
    },
    getMemberUserHistory: (payload) => {
        return {
            type:"MEMEBER_USER_HISTORY/GET_MEMBER_USER_HISTORY",
            payload
        }
    },
    exportMemberUserHistoryExcel: (payload) => {
        return {
            type: "MEMBER_USER_HISTORY/EXPORT_EXCEL",
            payload: payload
        }
    },
}

function* getPayerListAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_LOADING }));
        const response = yield HistoryDataService.getCascadePayers();
        if (response.data) {
            if (response?.data?.Status && response.data.Status === 1) {
                yield put(setPayerList(response.data.Data.map(payer => ({ label: payer.LastName, value: payer.PayerDetailId }))));
            }
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_READY }))
    }
}

function* getTaxYearsListAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_LOADING }));

        const { formId } = action?.payload;

        const response = yield FormsDataService.getCascadeTaxYears(formId || "");
        if (response.data) {
            if (response?.data?.Status && response.data.Status === 1) {
                yield put(setTaxYearList(response.data.Data.map(year => ({ label: year.ID, value: year.ID }))));
            }
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_READY }))
    }
}

function* getFormsListAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_LOADING }));
        const response = yield FormsDataService.getFormsList();
        
        const { Message, Status, Data } = response?.data;

        if (Status) {
            const formList = Data.Forms.map(form => ({ label: form.FormLabel, value: form.Id }))

            yield put(setFormList(formList));
            yield put(setSelectedForm(formList[0]))
        } else {
            yield put(addNotifications({ heading: "Failed to fetch forms list", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch forms list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.FILTER_READY }));
    }
}

function* getMemberUserHistoryAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_LOADING }));
        const response = yield HistoryDataService.getMemberUserHistoryDetails(action.payload);
        
        const { Message, Status } = response?.data;
        const Data = General.extractDataFromResponseData(response.data);
        
        if (Status) {
            yield put(setMemberUserHistory(Data))
            yield put(setTotalHistory(General.extractPaginationTotalFromResponse(response.data)))
            
        } else {
            yield put(addNotifications({ heading: "Failed to fetch forms list", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch forms list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_READY }));
    }
}

function* exportMemberUserHistoryExcelAsync() {
    try {
        yield put(setLoadingState({ state: COMMON_EXPORTING_STATES.EXPORT_LOADING }));
        const response = yield HistoryDataService.exportToExcel();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data))
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_EXPORTING_STATES.EXPORT_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getPayersList().type, getPayerListAsync),
        takeLatest(getTaxYearsList().type, getTaxYearsListAsync),
        takeLatest(getFormsList().type, getFormsListAsync),
        takeLatest(getMemberUserHistory().type, getMemberUserHistoryAsync),
        takeLatest(exportMemberUserHistoryExcel().type, exportMemberUserHistoryExcelAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);